import { useAuth } from '../context/AuthContext';
import { Link, useRawLocation, useNavigate } from '.';
import { parseTenantPath, tenantUrl } from '../utils/tenantPath';
import { allowedRestaurants } from './tenantAccess';

export function TenantNotice({ title, children, destination }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const leave = () => { logout(); navigate('/login', { replace: true }); };
  return (
    <main className="main-content" dir="rtl" style={{ padding: '64px 24px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.25rem' }}>{title}</h1>
      <div style={{ color: 'var(--ink-muted)' }}>{children}</div>
      {destination
        ? <Link className="btn btn-primary" style={{ minHeight: 44 }} to={destination}>למסעדה שלי</Link>
        : <button className="btn btn-secondary" style={{ minHeight: 44 }} onClick={leave}>התנתקות</button>}
    </main>
  );
}

export default function TenantGate({ children }) {
  const { user, realRole, restaurants, restaurantsLoaded, restaurantsError,
    sessionChecked, sessionError, deniedTenantId, refreshSession } = useAuth();
  const { rid, invalid } = parseTenantPath(useRawLocation().pathname);
  const allowed = allowedRestaurants(realRole, user, restaurants);
  const own = allowed.find(r => String(r.id) !== deniedTenantId);
  const destination = own ? tenantUrl(own.id, '/suppliers') : null;
  if (invalid) return <TenantNotice title="המסעדה לא נמצאה" destination={destination}>בדקו את הקישור ונסו שוב.</TenantNotice>;
  const knownAllowed = (realRole !== 'admin' || restaurantsLoaded) && allowed.some(r => String(r.id) === rid);
  const failed = sessionError || restaurantsError;
  // Explicit revocation always wins; a transient refresh must never destroy a form.
  if (deniedTenantId !== rid && knownAllowed) return <>
    {failed && <div role="alert" dir="rtl" style={{ padding: 12 }}>לא הצלחנו לרענן את הגישה. אפשר לנסות שוב. <button className="btn btn-secondary" style={{ minHeight: 44 }} onClick={refreshSession}>נסו שוב</button></div>}
    {children}
  </>;
  if (deniedTenantId !== rid && failed) return (
    <TenantNotice title="לא הצלחנו לבדוק את הגישה למסעדה" destination={destination}>
      <button className="btn btn-primary" style={{ minHeight: 44 }} onClick={refreshSession}>נסו שוב</button>
    </TenantNotice>
  );
  if (deniedTenantId !== rid && (!sessionChecked || (realRole === 'admin' && !restaurantsLoaded))) {
    return <TenantNotice title="בודקים את הגישה למסעדה"><span role="status">רק רגע…</span></TenantNotice>;
  }
  return <TenantNotice title={realRole === 'admin' ? 'המסעדה לא נמצאה' : 'אין לך גישה למסעדה זו'} destination={destination}>
    אפשר לעבור למסעדה שיש לך גישה אליה. אם אין מסעדה זמינה, פנו לצוות Peak.
  </TenantNotice>;
}
